/* eslint-disable react/no-unknown-property */
import Image from 'next/image'
import React from 'react'

export default function Sec2() {
  return (
    <div>
      <section id="2" className="font-inter">
        <div className="grid md:col-span-12 relative">
          <div className="">
            <div className="font-bold lg:leading-[40px] tracking-[-1.21px] lg:text-[45px] md:text-[51px] text-[35px] flex items-center justify-center max-w-[400px] text-center lg:pb-6 mb-4 lg:max-w-[650px] mx-auto ">
              <h2 className="ml-3 md:flex md:items-center md:justify-center lg:mb-0 md:mb-40 mb-52 leading-[1.1111112]">
                Create a form in seconds.
              </h2>
            </div>

            <Image
              alt="Image"
              src="/ai/1.png"
              width={189}
              height={176}
              className="z-1000000 absolute left-[3%] bottom-0"
            />
          </div>
        </div>
        <div className="border bg-slate-100 rounded-md mt-[-14px] lg:width-full px-8 py-6">
          <div className="lg:w-[512px] top-[24px] flex flex-col">
            <div className="border-transparent w-[26px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                width="1em"
                className="w-[26px] h-[26px]"
                style={{
                  fill: '#9d34da',
                  color: '#9d34da'
                }}
              >
                <defs fill="currentColor" />
                <path
                  d="m32,8c-14.81,0-24,8.43-24,22,0,6.92,2.4,12.49,6.7,16.3l-6.7,6.7,2,3c5.42,0,10.43-1.8,14.45-4.84,2.32.55,4.84.84,7.55.84,14.81,0,24-8.43,24-22s-9.19-22-24-22Zm0,8c4.94,0,8,3.06,8,8s-3.06,8-8,8-8-3.06-8-8,3.06-8,8-8Zm0,30c-5.6,0-10.03-1.41-13.09-4.03,2.72-3.81,7.24-5.97,13.09-5.97s10.37,2.16,13.09,5.97c-3.06,2.62-7.49,4.03-13.09,4.03Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h3 className="postTitle">Get help with any question</h3>
            <p className="text-slate-700 text-lg lg:max-w-[463px]">
              Need a form but don’t know where to start? Create custom forms in
              seconds and get AI guidance every step of the way, no matter the
              question.
            </p>
          </div>
          {/* video */}
          <div className="pt-6">
            <video
              src="/WebsiteAnimation.mp4"
              autoPlay
              loop
              muted
              className="border rounded-xl w-full h-auto object-cover"
            ></video>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 lg:gap-9 md:gap-3 gap-3 my-8 w-[full] h-auto">
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <Image width={350} height={400} alt="" src="/ai/Process.png" />
          </div>
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <Image width={350} height={400} alt="" src="/ai/Meetings.png" />
          </div>
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <Image width={350} height={400} alt="" src="/ai/Projects.png" />
          </div>
        </div>
        <div className="mt-12">
          <p className="mx-auto flex items-center justify-center text-2xl max-w-xl text-center font-medium">
            {`"Previously, we had to guess which platform held the information we needed. Now, people can simply ask Notion AI."`}
          </p>
          <div className="flex items-center justify-center gap-3">
            <Image
              src="/ai/hex.png"
              alt="hex-logo"
              width={50}
              height={20}
              className="rounded-md"
            />
            <div className="my-5 flex flex-col justify-start items-start">
              <p>Ganesh Ramanarayanan</p>
              <p className="font-semibold">Head of Engineering, Hex</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
